const KL_DESCRIPTION_SELECTOR = '[data-kl-description]';
const KL_DESCRIPTION_BODY_SELECTOR = '[data-kl-description-body]';
const KL_DESCRIPTION_TOGGLE_SELECTOR = '[data-kl-description-toggle]';
const KL_DESCRIPTION_OVERFLOW_TOLERANCE = 2;

function getIsOverflowing(scrollHeight, clientHeight) {
  return scrollHeight - clientHeight > KL_DESCRIPTION_OVERFLOW_TOLERANCE;
}

function initDescription(root) {
  if (!root) return;

  const body = root.querySelector(KL_DESCRIPTION_BODY_SELECTOR);
  const toggle = root.querySelector(KL_DESCRIPTION_TOGGLE_SELECTOR);

  if (!body || !toggle) return;

  const isOverflowing = getIsOverflowing(body.scrollHeight, body.clientHeight);

  root.classList.toggle('is-not-clamping', !isOverflowing);

  toggle.addEventListener('click', () => {
    const isExpanded = !root.classList.contains('is-expanded');

    root.classList.toggle('is-expanded', isExpanded);
    toggle.setAttribute('aria-expanded', String(isExpanded));
    toggle.textContent = isExpanded
      ? toggle.dataset.klDescriptionCollapseLabel
      : toggle.dataset.klDescriptionExpandLabel;
  });
}

document.querySelectorAll(KL_DESCRIPTION_SELECTOR).forEach(initDescription);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll(KL_DESCRIPTION_SELECTOR).forEach(initDescription);
});
